import * as actions from './actions';
import * as getters from './getters';
import {FETCH_FOOTER } from '../../mutation-types';


const mutations = {
  [FETCH_FOOTER](state, payload) {
    state.footer = payload
  },
};

const state = {
  footer: null,
  url: '/v1/footer'
};

export default {
  namespaced: true,
  mutations,
  actions,
  getters,
  state,
};
